import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { withStyles } from "@material-ui/core/styles";
import {
  SimpleForm,
  SelectInput,
  ReferenceInput,
  translate,
  crudUpdateMany,
  NumberInput,
  number,
  minValue,
  maxValue,
} from "react-admin";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { submit } from "redux-form";
import SimpleButton from "@material-ui/core/Button";
import SaveButton from "../common/SaveButton";
import { startUndoable as startUndoableAction } from "ra-core";

const styles = {
  button: { marginRight: "1em", marginLeft: "1em" },
};

const validateInteger = (value, allValues, props) => {
  if (value && !Number.isInteger(value)) {
    return props.translate("ra.validation.integer");
  }
};

const validateCapacity = [
  number(),
  minValue(1),
  maxValue(9999),
  validateInteger,
];

class ResourceBulkUpdateButton extends Component {
  state = {
    showDialog: false,
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    submit("bulk-resource-update");
  };

  handleSubmit = (values) => {
    const { basePath, resource, selectedIds: ids, startUndoable } = this.props;
    startUndoable(
      crudUpdateMany(resource, ["batch"], { ids, ...values }, basePath)
    );
    this.setState({ showDialog: false });
  };

  render() {
    const { showDialog } = this.state;
    const { translate } = this.props;
    return (
      <Fragment>
        <SimpleButton
          variant="outlined"
          onClick={this.handleClick}
          style={styles.button}
          color="primary"
        >
          {translate("resources.resources.fields.bulkUpdate")}
        </SimpleButton>
        <Dialog fullWidth open={showDialog} onClose={this.handleCloseClick}>
          <DialogTitle>
            {translate("resources.resources.fields.bulkUpdate")}
          </DialogTitle>
          <DialogContent>
            <SimpleForm
              toolbar={null}
              form="bulk-resource-update"
              onSubmit={this.handleSubmit}
              submitOnEnter={false}
            >
              <NumberInput
                source="capacity"
                allowEmpty
                label="resources.resources.fields.capacity"
                validate={validateCapacity}
              />
              <ReferenceInput
                source="operationRuleId"
                reference="operation-rules"
                allowEmpty
                label="resources.resources.fields.operationRule"
                sort={{ field: "name", order: "ASC" }}
              >
                <SelectInput optionText="name" />
              </ReferenceInput>
              <SelectInput
                source="isMonitored"
                label="resources.resources.fields.isMonitored"
                allowEmpty
                choices={[
                  {
                    id: true,
                    name: "resources.resources.enums.monitoring.true",
                  },
                  {
                    id: false,
                    name: "resources.resources.enums.monitoring.false",
                  },
                ]}
              />
            </SimpleForm>
          </DialogContent>
          <DialogActions>
            <SaveButton onClick={this.handleSaveClick} />
            <SimpleButton onClick={this.handleCloseClick} color="primary">
              {translate("ra.action.cancel")}
            </SimpleButton>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

ResourceBulkUpdateButton.propTypes = {
  record: PropTypes.object,
  startUndoable: PropTypes.func,
};

const enhance = compose(
  translate,
  withStyles(styles),
  connect(undefined, {
    submit,
    startUndoable: startUndoableAction,
    crudUpdateMany,
  })
);

export default enhance(ResourceBulkUpdateButton);
